import { MIN_SLIDE_INDEX } from "../../constants";

export const getIsExtraSlideTemporaryActive = ({
  index,
  currentExtraSlidesMultiplier,
  slidesCount,
  extraSlidesMultiplier,
  activeSlideIndex,
}: {
  index: number;
  currentExtraSlidesMultiplier: number;
  slidesCount: number;
  extraSlidesMultiplier: number;
  activeSlideIndex: number;
}) => {
  let temporaryActiveSlide = false;

  if (activeSlideIndex < MIN_SLIDE_INDEX) {
    temporaryActiveSlide =
      slidesCount - Math.abs(activeSlideIndex) === index &&
      currentExtraSlidesMultiplier === extraSlidesMultiplier - 1;
  } else if (activeSlideIndex > slidesCount - 1) {
    temporaryActiveSlide =
      slidesCount - activeSlideIndex === index &&
      currentExtraSlidesMultiplier === 0;
  }

  return temporaryActiveSlide;
};
